import { useQuery } from '@apollo/client'
import { GET_AD_HISTORY_ENABLED } from '@/graphql/ad-history-queries'

/**
 * Whether reading past ad results is switched on for the licence, for the navigation entry. Anything but a clear yes
 * (still loading, no access, a failed read) hides the entry; the page itself explains what is going on.
 */
export const useAdHistoryEnabled = (campaignId: string | null | undefined): boolean => {
    const { data } = useQuery<{ adHistoryStatus: { enabled: boolean } }>(GET_AD_HISTORY_ENABLED, {
        variables: { campaignId },
        skip: !campaignId,
        errorPolicy: 'ignore',
    })
    return data?.adHistoryStatus?.enabled === true
}
